document.addEventListener('DOMContentLoaded', function() {
    if (typeof Swiper !== 'undefined') {
        const featruredPostsSwiper = new Swiper('.featrured-posts-swiper', {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 25,
            grabCursor: true,
            navigation: {
                nextEl: '.featrured-posts-next',
                prevEl: '.featrured-posts-prev',
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 4,
                },
            },
        });
    }
});